/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityFeedResponse } from '../../models/activity-feed-response';

export interface GetPendingActivities$Params {
  page: number;
  pageSize: number;
}

export function getPendingActivities(http: HttpClient, rootUrl: string, params: GetPendingActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityFeedResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPendingActivities.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityFeedResponse>>;
    })
  );
}

getPendingActivities.PATH = '/api/activities/pending';
